import {
    createVNode as _$cv,
    className as _$cn,
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Icon} from '../icon';
import {isInvalid} from 'intact-shared';
import {getRestProps, isEmptyString} from '../utils';
import {makeStyles} from './styles';

var _$tmp0 = {
    'className': 'ion-person'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    const {
        shouldShowLoadingShell,
        shouldShowAvatar,
        hasRoleName,
        shouldShowContentBlock,
        getBubbleStyle,
        getRoleNameText,
        getAvatarText,
        hasNonEmptyContentProp,
        getDisplayedContent,
    } = this.display;
    
    const {
        className, placement, avatar, variant, shape, children,
    } = this.get();
    const {k} = this.config;
    const showLoadingShell = shouldShowLoadingShell();
    const slotRenderers = this.getSlotRenderers();
    const renderSlot = (name) => {
        if (slotRenderers[name]) return slotRenderers[name]();
        if ($blocks[name]) return $blocks[name](() => undefined);
    };
    const isEmptySlot = (value) => {
        if (isInvalid(value) || isEmptyString(value)) return true;
        if (Array.isArray(value)) return value.every(item => isEmptySlot(item));
        if (value.type === 1) return isEmptySlot(value.children);
    
        return false;
    };
    
    const avatarSlot = renderSlot('avatar');
    const roleNameSlot = renderSlot('roleName');
    const beforeContentSlot = renderSlot('beforeContent');
    const attachmentsSlot = renderSlot('attachments');
    const contentSlot = showLoadingShell ? undefined : renderSlot('content');
    const bottomSlot = renderSlot('bottom');
    const footerSlot = renderSlot('footer');
    const loadingSlot = showLoadingShell ? renderSlot('loading') : undefined;
    const extraSlot = renderSlot('extra');
    
    const hasAvatarSlot = !isEmptySlot(avatarSlot);
    const hasRoleNameSlot = !isEmptySlot(roleNameSlot);
    const hasBeforeContentSlot = !isEmptySlot(beforeContentSlot);
    const hasAttachmentsSlot = !isEmptySlot(attachmentsSlot);
    const hasContentSlot = !isEmptySlot(contentSlot);
    const hasBottomSlot = !isEmptySlot(bottomSlot);
    const hasFooterSlot = !isEmptySlot(footerSlot);
    const hasLoadingSlot = !isEmptySlot(loadingSlot);
    const hasExtraSlot = !isEmptySlot(extraSlot);
    
    const showAvatar = hasAvatarSlot || shouldShowAvatar();
    const showHeader = hasRoleNameSlot || hasRoleName();
    const showBeforeContent = hasBeforeContentSlot;
    const showAttachments = hasAttachmentsSlot;
    const showContent = showAttachments || hasContentSlot || !!children || shouldShowContentBlock();
    const showFooter = hasFooterSlot;
    const showBubble = showBeforeContent || showContent || showFooter;
    const showMeta = (showBeforeContent || showContent) && (showAvatar || showHeader);
    
    const classNameObj = {
        [`${k}-bubble`]: true,
        [`${k}-bubble-${placement}`]: true,
        [`${k}-bubble-${variant}`]: true,
        [`${k}-bubble-${shape}`]: true,
        [className]: className,
        [makeStyles(k)]: true,
    };
    
    return (showBubble) ?
        _$cv('div', {
            'className': _$cn(classNameObj),
            ...getRestProps(this)
        }, (
            _$ce(2, 'div', [
                (showMeta) ?
                    _$ce(2, 'div', [
                        (showAvatar) ?
                            _$ce(2, 'div', (
                                (hasAvatarSlot) ?
                                    avatarSlot :
                                    typeof avatar === 'string' && avatar ?
                                        _$ce(2, 'img', null, 1, _$cn(`${k}-bubble-avatar-image`), {
                                            'src': avatar,
                                            'alt': getRoleNameText() || 'avatar'
                                        }) :
                                        getAvatarText() ?
                                            _$ce(2, 'span', getAvatarText(), 0) :
                                            _$cc(Icon, _$tmp0)
                            ), 0, _$cn(`${k}-bubble-avatar`)) :
                            undefined,
                        (showHeader) ?
                            _$ce(2, 'div', (
                                (hasRoleNameSlot) ?
                                    roleNameSlot :
                                    _$ce(2, 'span', getRoleNameText(), 0)
                            ), 0, _$cn(`${k}-bubble-header`)) :
                            undefined
                    ], 0, _$cn(`${k}-bubble-meta`)) :
                    undefined,
                (showBeforeContent) ?
                    _$ce(2, 'div', beforeContentSlot, 0, _$cn(`${k}-bubble-before-content`)) :
                    undefined,
                (showContent) ?
                    _$ce(2, 'div', [
                        (showAttachments) ?
                            _$ce(2, 'div', attachmentsSlot, 0, _$cn(`${k}-bubble-attachments`)) :
                            undefined,
                        (showLoadingShell) ?
                            (
                                (hasLoadingSlot) ?
                                    loadingSlot :
                                    _$ce(2, 'div', [
                                        _$ce(2, 'span', null, 1, _$cn(`${k}-bubble-loading-dot`)),
                                        _$ce(2, 'span', null, 1, _$cn(`${k}-bubble-loading-dot`)),
                                        _$ce(2, 'span', null, 1, _$cn(`${k}-bubble-loading-dot`))
                                    ], 4, _$cn(`${k}-bubble-loading`))
                            ) :
                            hasContentSlot ?
                                contentSlot :
                                children ?
                                    children :
                                    hasNonEmptyContentProp() || getDisplayedContent() ?
                                        _$ce(2, 'div', getDisplayedContent(), 0, _$cn(`${k}-bubble-text`)) :
                                        undefined,
                        (hasBottomSlot) ?
                            _$ce(2, 'div', bottomSlot, 0, _$cn(`${k}-bubble-bottom`)) :
                            undefined
                    ], 0, _$cn(`${k}-bubble-content`)) :
                    undefined,
                (showFooter) ?
                    _$ce(2, 'div', footerSlot, 0, _$cn(`${k}-bubble-footer`)) :
                    undefined,
                (hasExtraSlot) ?
                    _$ce(2, 'div', extraSlot, 0, _$cn(`${k}-bubble-extra`)) :
                    undefined
            ], 0, _$cn(`${k}-bubble-main`), {
                'style': getBubbleStyle()
            })
        )) :
        undefined;
};